import React from 'react';
import classNames from "classnames";
import numbro from 'numbro';

// react plugin for creating charts
import ChartistGraph from "react-chartist";
import Chartist from 'chartist';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

import Sync from '@material-ui/icons/Sync';
import SyncDisabled from '@material-ui/icons/SyncDisabled';

// Core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";
import { Context } from "Context.jsx";

import CLCColors from "assets/data/clc_colors.js";
import CLCChartZoom from "components/CLCDataCards/CLCChartZoom";

Chartist.plugins.ctHtmlLabels = function (options) {
  return function (chart) {
    chart.on('draw', function (context) {
      if (context.type === 'label') {
        // Best to combine with something like sanitize-html
        context.element.empty()._node.innerHTML = context.text;
      }
    });
  }
}

class CLCTrendsChartCard extends React.Component {

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      chart_width: "",
      high_ha: undefined
    }

    this.tooltipFnc = this.tooltipFnc.bind(this);
    this.handleZoom = this.handleZoom.bind(this);
    this.handleSync = this.handleSync.bind(this);
    this.handleZoomMount = this.handleZoomMount.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('resize', this.updateChartSize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateChartSize.bind(this))
    this._isMounted = false;
  }

  updateChartSize() {
    let el = document.getElementById(this.props.id);
    if (el && this._isMounted) {
      this.setState({
        chart_width: el.offsetWidth
      });
    }
  }

  calcAxisYHigh(val) {
    let min = this.minY || 1;
    let max = this.maxY || 1;

    let exp = Math.log10(max);
    let step = exp / 9;

    let step_values = [12, 8, 7, 6, 5, 4, 3, 2, 1];
    step_values = step_values.map(x => Math.round(5 * min + (max / Math.exp(x * step))));

    let values = new Array();
    values.push(5 * min);
    values = values.concat(step_values);
    values.push(undefined);

    let ord = (val / 10);

    return values[ord];
  }

  handleZoom(val) {
    if (this.props.onSetZoom) {
      this.props.onSetZoom(val);
    }
  }

  handleZoomMount(slider) {
    this.slider = slider;
  }

  handleSync() {
    if (this.props.onSetSync) {
      this.props.onSetSync();
    }
  }

  tooltipFnc(meta, value) {
    const { t } = this.props;
    if (meta) {
      let parts = meta.split(';')
      let code = parts[0];
      let unit = parts[1];
      return t("map:code") + ": " + code + "<br/>"
        + t("clc:" + code) + "<br/>"
        + t("map:area") + ": " + numbro(value * 100).divide(100).format() + " " + unit;
    } else {
      return numbro(value * 100).divide(100).format();
    }
  };

  chartListener() {
    return {
      draw: function (data) {
        if (data.type === "grid") {
          data.element.attr({
            style: 'stroke: rgba(0,0,0,.2); stroke-width:1px; stroke-dasharray: 2px;'
          })
        }
        if ((data.type === "line" || data.type === "area" || data.type === "point")
          && (data.series.length > 0)) {
          let meta = data.series.filter(function (el) {
            return el != null;
          })[0].meta;
          let parts = meta.split(';');
          let clc_code = parts[0];
          let clc_color = CLCColors[clc_code];

          if (data.type === "line" || data.type === "area") {
            data.element.attr({
              style: 'stroke: ' + clc_color + '; stroke-width:2px; fill: rgba(255, 255, 255, 0);'
            });
          } else if (data.type === "point") {
            data.element.attr({
              style: 'stroke: ' + clc_color + '; stroke-width:10px; stroke-linecap: round;'
            });
          }

          else if (data.type === "line" || data.type === "point") {
            data.element.attr({
              style: 'stroke: ' + clc_color + ';'
            });
          }
        }
      }
    }
  }

  chartOptions(width, unit) {

    let axisYhigh = this.calcAxisYHigh(this.props.zoom);

    if (!width) {
      let el = document.getElementById(this.props.id);
      if (el) {
        width = el.offsetWidth;
      }
    }

    return {
      axisX: {
        showGrid: false,
        labelInterpolationFnc: function (value, index, data) {
          return '<span class="ct-label ct-horizontal ct-end" style="color: rgba(0,0,0,.7); font-size:.75rem;">' + value + '</span>';
        }
      },
      axisY: {
        showGrid: true,
        offset: 100,
        low: 0,
        high: axisYhigh ? unit.transform(axisYhigh) : undefined,
        labelInterpolationFnc: function (value, index, data) {
          let suffix = "";
          if (index === data.length - 1 && axisYhigh) {
            suffix = " +"
          }
          if (value > 1) {
            return '<span class="ct-label ct-horizontal ct-end" style="height: 100%; width: 100%; color: rgba(0,0,0,.7); font-size:.75rem; display:flex; -webkit-box-align: flex-end; -ms-flex-align: flex-end;align-items: flex-end;-webkit-box-pack: flex-end;-webkit-justify-content: flex-end;-ms-flex-pack: flex-end;justify-content: flex-end;text-align: right;text-anchor: end;">' + numbro(value).format({ mantissa: 0 }) + suffix + '</span>';
          }
          else {
            return '<span class="ct-label ct-horizontal ct-end" style="height: 100%; width: 100%; color: rgba(0,0,0,.7); font-size:.75rem; display:flex; -webkit-box-align: flex-end; -ms-flex-align: flex-end;align-items: flex-end;-webkit-box-pack: flex-end;-webkit-justify-content: flex-end;-ms-flex-pack: flex-end;justify-content: flex-end;text-align: right;text-anchor: end;">' + numbro(value).format({ mantissa: 2 }) + suffix + '</span>';
          }
        }.bind(this)

      },

      showPoint: true,
      height: this.props.height,
      width: width,
      plugins: [
        Chartist.plugins.tooltip({
          metaIsHTML: false,
          tooltipFnc: this.tooltipFnc
        }),
        Chartist.plugins.ctHtmlLabels()
      ]
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  chartData(unit) {

    let data = this.props.trendsData;

    this.minY = undefined;
    this.maxY = 0;

    let labels = data.map(x => x.y).filter(this.onlyUnique);
    let labels_length = labels.length;

    let type_data = data.reduce(function (result, current) {
      result[current[this.props.idCol]] = result[current[this.props.idCol]] || [];
      result[current[this.props.idCol]].push(current);
      return result;
    }.bind(this), []);
    type_data = type_data.filter(function (el) {
      return el != undefined;
    });

    let series = [];
    let values = [];

    for (let i = 0; i < type_data.length; i++) {
      let el = type_data[i];

      let s = new Array(labels_length).fill(null);

      for (let j = 0; j < el.length; j++) {
        let ind = labels.indexOf(el[j].y);
        let val_ha = el[j][this.props.areaCol];
        let val = unit.transform(el[j][this.props.areaCol]);
        values.push(parseFloat(val_ha));
        s[ind] = { meta: el[j][this.props.idCol] + ";" + unit.short, value: val }
      }
      series.push(s);
    }

    this.minY = Math.min(...values);
    this.maxY = Math.max(...values);

    // for (let i = 0; i < data.length; i++) {
    //   let el = data[i];

    //   let s = [];
    //   for (let j = 0; j < labels.length; j++) {
    //     let label = labels[j];
    //     let col =  this.props.areaCol + '_' + label;

    //     if (el[col] >= 0) {
    //       s.push({meta: el[this.props.idCol], value: unit.transform(el[col])});
    //     }
    //   }
    //   series.push(s);
    // }

    return {
      labels: labels,
      series: series
    };
  }

  footerData(unit) {
    return <div></div>
  }

  _getTitle(data) {
    if (this.props.title) {
      return this.props.title;
    }
    else if (data && data.length > 0) {
      let d = data[0];
      if (d.title_trans_token) {
        return d.title_trans_token;
      } else if (d.title) {
        return d.title;
      }
    } else {
      return null;
    }
  }

  addStringsWithPx(aPx, bPx) {
    let a = parseInt(aPx.replace("px", ""));
    let b = parseInt(bPx.replace("px", ""));

    return (a + b).toString() + "px";
  }

  render() {
    const { t, classes } = this.props;

    if (this.slider && this.props.zoom && this.slider.get() !== this.props.zoom) {
      this.slider.set(this.props.zoom);
    }

    return (
      <Context.Consumer>
        {ctx =>
          <Card>
            <CardHeader color={this.props.color} >
              <CardIcon color={this.props.color}>
                <Icon>timeline</Icon>
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t(this._getTitle(this.props.allData)) || t("map:trends")}
                <small> - {this.props.subtitle || t("map:level-3")}</small>
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={1} >
                  <GridContainer spacing={0}>
                    <GridItem xs={12} style={{ height: this.addStringsWithPx(this.props.height, "-40px"), paddingLeft: "32px" }}>
                      <CLCChartZoom
                        color={this.props.color}
                        val={this.props.zoom}
                        onSet={this.handleZoom}
                        onMount={this.handleZoomMount}
                      />
                    </GridItem>
                  </GridContainer>
                  {this.props.showSync ?
                    <GridItem xs={12} style={{ paddingTop: "10px" }} >
                      <Tooltip title={t('common:change-sync')}>
                        <Button onClick={this.handleSync} className={classNames("noUiChart-" + this.props.color, classes.white, classes.sizeTiny)}>
                          {this.props.sync ? <Sync /> : <SyncDisabled />}
                        </Button>
                      </Tooltip>
                    </GridItem>
                    : null}

                </GridItem>
                <GridItem xs={11} style={{ paddingLeft: "0px" }}>
                  <div id={this.props.id}>
                    <ChartistGraph
                      data={this.chartData(ctx.unit)}
                      type="Line"
                      options={this.chartOptions(this.state.chart_width, ctx.unit)}
                      listener={this.chartListener()}
                    />
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter className={classes.cardFooter}>
              <small className={classes.cardFooter}>
                {this.footerData(ctx.unit)}
              </small>
            </CardFooter>
          </Card>
        }
      </Context.Consumer>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCTrendsChartCard));
